import React from 'react';

import { ApButtonSecondary, ApButtonDanger } from '@alixpartners/ui-components';
import { StyledModal } from './CommonDialog.styles';

export const CommonDialog = ({
	onClose,
	onDelete,
	title,
	cancelText = 'Cancel',
	body,
	suppressFooter,
	maxWidth,
}) => {
	return (
		<StyledModal
			maxWidth={maxWidth}
			header={title}
			footer={
				suppressFooter
					? undefined
					: () => (
							<React.Fragment>
								<ApButtonSecondary onClick={onClose}>
									{cancelText}
								</ApButtonSecondary>

								{onDelete && (
									<ApButtonDanger onClick={onDelete}>Delete</ApButtonDanger>
								)}
							</React.Fragment>
					  )
			}
			hasClosed={onClose}
			isDismissible
			isOpen
		>
			{body}
		</StyledModal>
	);
};
